<template>
  <div> {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Utilitario Consulta Facturas Externa'" :titulo="'Utilitario Consulta Facturas Externa'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
      <tr>

        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">
              <v-card color="grey lighten-3">

                <div class="px-2 pb-2" style="border: 1px solid #000000">
                  <v-form ref="formFactVenta" v-model="valid" lazy-validation @submit.prevent="">

                    <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                      <v-row class="pa-0 ma-0 py-0 my-0">


                        <v-col v-if="false" class="pa-0 ma-0 px-2 py-1" cols="12" md="2" sm="2">
                          <v-text-field v-model.number="ConsultaFacturas.factura" autocomplete="off" dense hide-details
                                        label="No.Factura:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="getFacVenta" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>


                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field v-if="false" v-model="ConsultaFacturas.ncf" autocomplete="off" dense hide-details label="NCF"
                                        outlined style="font-size: 12px;" @blur="getFacVenta">
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                          <v-text-field v-model.number="ConsultaFacturas.cantreg" autocomplete="off" dense hide-details
                                        label="Cant.Registro:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="getFacVenta" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                      <!-- <v-row class="pa-0 ma-0 py-0 my-0" ></v-row> -->
                          <center v-show="false" >
                        <!-- class="pa-0 ma-0 py-0 my-0" :class="`d-flex justify-center white--text`"-->
                        <!-- <v-row no-gutters></v-row> -->
                        <span style="font-size: 12px"><b>OPCION FAC. ELECTRÓNICO:</b>
                          <!-- <span style="color: #C62828;"> Para </span> --> </span>
                        <v-radio-group v-model="ConsultaFacturas.opcion" class="pt-0 mt-0 d-flex justify-center " dense
                                       hide-details
                                       row @change="getFacVenta">
                          <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                          <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                          <v-radio :value="0" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">TODOS</strong>
                            </template>
                          </v-radio>
                          <v-radio id="no-enviada" :value="1" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">NO ENVIADA</strong>
                            </template>
                          </v-radio>

                          <v-radio :value="2" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">ENVIADA</strong>
                            </template>
                          </v-radio>


                        </v-radio-group>
                        <v-text-field v-if="ConsultaFacturas.opcion==2" v-model="ConsultaFacturas.buscarTrackId"
                                      autocomplete="off"
                                      class="pt-0 mt-0 fontSize12"
                                      dense hide-details label="" single-line style="border:1px solid #000000;"
                                      @blur="getFacVenta">
                          <template v-slot:prepend-inner>
                            <i class="fa fa-search" style="font-size: 20px;"></i>
                          </template>
                          <template v-slot:label>
                            <!-- <strong style="color: #000000; font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</strong> -->
                            <span style="font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</span>
                          </template>
                        </v-text-field>
                         </center>
                          <center v-if="ConsultaFacturas.opcion==1" >
                            <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                      <!-- actualizarFacEletronico(DtoFacturaVentas) -->
                                    <v-btn id="actualizar-factura" color="blue" dark outlined
                                          small v-on="on" @click.prevent="enviarTodaFactura()">
                                      <i class="fa fa-plus-square" style="font-size: 20px;"></i> ENVIAR TODAS LAS FACTURA
                                    </v-btn>

                                  </template>
                                  <span>ENVIAR TODAS LAS FACTURA</span>
                                </v-tooltip>
                          </center>            
                    </v-col>
                      </v-row>
                    </v-col>
                  </v-form>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <div style="border: 1px solid #000000">
                      <!-- @click:row="datostabla" -->
                      <v-data-table
                          v-if="resertPagi == true"
                          id="facturas-table"
                          v-model="selected"
                          :footer-props="arrayPropiedases"
                          :headers="[
                            { text: 'Código', sortable: false, value: 'codigo', width: 120 , class: ['no-gutters black--text'] },
                          { text: 'Fecha Emision', sortable: false, value: 'fechaEmision', width: 120 , class: ['no-gutters black--text'] },
                          { text: 'eNCF', sortable: false, value: 'encf', width: 200,class: ['no-gutters black--text'] },
                          { text: 'Comprador', sortable: false, value: 'comprador', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Código Seguridad', sortable: false, value: 'codSeguridad', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Monto Total', sortable: false, value: 'montoTotal', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Estado', sortable: false, value: 'estado', width: 150, class: ['no-gutters black--text'] },
                        ]"
                          :items="listFactVent"
                          :items-per-page="paginator.itemsPerPage"
                          :search="search"
                          :server-items-length="TotalRegistros"
                          :show-select="true"
                          :single-select="true"
                          class="elevation-1 RowSelectColor TbSize13"
                          dense
                          item-key="indx"
                          @pagination="cargarPaginacion"
                          @item-selected="obtenerDatoSelect"
                          @click:row="datostabla"
                          hide-default-footer
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <!-- <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)">
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn> -->
                        </template>

                        <template v-slot:item.fechaEmision="props">
                          <span style="font-size: 13px; display: none">
                            {{ (props.item.indx = `${listFactVent.indexOf(props.item)}-${props.item.codigo}`) }}
                          </span>
                          <span  style="font-size: 13px">
                            {{ dataFechaEmision(props.item)}}

                          </span>
                        <!-- FormatoFecha(props.item.fecha) -->
                        </template>

                        <template v-slot:item.encf="props">
                          <span style="font-size: 13px">{{ dataEncf(props.item)}}</span>
                        </template>

                        <template v-slot:item.comprador="props">
                          <span style="font-size: 13px">
                           {{ props.item.contenidoJson.encabezado.comprador==null?"CONTADO":props.item.contenidoJson.encabezado.comprador.rncComprador}}
                          </span>
                        </template>

                        <template v-slot:item.codSeguridad="props">
                          <!-- <span style="font-size: 13px">{{props.item.contenidoJson.encabezado.codigoSeguridadeCF!=null?props.item.contenidoJson.encabezado.codigoSeguridadeCF:'N/A'}}</span> -->
                       {{getCodSeguridad(props.item)}}
                        </template>

                        <template v-slot:item.montoTotal="props">
                          <span v-if="props.item.contenidoJson.encabezado.totales!=null" style="font-size: 13px">{{ props.item.contenidoJson.encabezado.totales.montoTotal}}</span>
                        </template>
                        
                        <template v-slot:item.estado="props">
                          <span style="font-size: 13px"> <b :class="claseColorEstado(props.item.trackId)">{{ getEstado(props.item.trackId) }}</b>
                            
                          </span>
                        </template>

                        <!-- <template v-slot:item.valor="props">
                          <span style="font-size: 13px">{{ currencyFormatter(props.item.valor) }}</span>
                        </template> -->

                        <!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:11px; color: #00838F;">Total de horas:</strong></td>
         
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(Totales.totalHora)}} </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
  </tr>
 </template>
<template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total de horas:{{currencyFormatter(Totales.totalHora)}} </span>
      

      </v-list-item-content>
    </v-list-item>

  </template> -->
                      </v-data-table>
                    </div>
                    </v-col>

                </div>
              </v-card>
              <hr/>
              <v-card color="grey lighten-3">
                <div class="px-2 pt-1" style="border: 1px solid #000000">
                  <!-- Facturacion Electronica -->
                   <!--v-if="activarModuloEletronica(DtoFacturaVentas)==true  -->
                <v-col v-if="DtoFacturaVentas!=null" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
                  <v-card>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                      <span><b>Facturación Electrónica</b></span>
                    </v-col>

                    <!-- cuerpo FACTURACION ELETRONICA -->
                    <v-col cols="12" md="12" sm="12">
                      <v-row>
                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <!-- actualizarFacEletronico(DtoFacturaVentas) -->
                              <v-btn id="actualizar-factura" color="blue" dark outlined
                                     small v-on="on" @click.prevent="actualizarFacEletronico(DtoFacturaVentas)">
                                <i class="fa fa-plus-square" style="font-size: 20px;"></i> ACTUALIZAR FACT.ELECTRONICA
                              </v-btn>

                            </template>
                            <span>ACTUALIZAR FACT.ELECTRONICA</span>
                          </v-tooltip>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                         <v-text-field id="formdisabledInput" v-model="DtoFacturaVentas.codigo" :disabled="true" dense
                                      label="Código:" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-list-ol" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>
                        
                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-text-field id="formdisabledInput" :value="DtoFacturaVentas.contenidoJson.encabezado.codigoSeguridadeCF!=null?DtoFacturaVentas.contenidoJson.encabezado.codigoSeguridadeCF:'N/A'"
                                        autocomplete="off" dense
                                        disabled
                                        hide-details label=" signatureValue:" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-shield" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-text-field id="formdisabledInput" :value="DtoFacturaVentas.contenidoJson.encabezado.emisor.fechaEmision"
                                        autocomplete="off"
                                        dense disabled
                                        hide-details label="fechafirmadgii" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="DtoFacturaVentas.qr" auto-grow
                                      autocomplete="off" dense
                                      disabled hide-details label="QR:" outlined
                                      rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="DtoFacturaVentas.trackId" auto-grow
                                      autocomplete="off" dense
                                      hide-details label="trackId:" outlined rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                        <pre style="font-size: 10px;">
                          AMBIENTE:(testecf/certecf/ecf)
                          CONSULTA:
                          1- https://ecf.dgii.gov.do/{AMBIENTE}/consultaresultado/help/index.html
                          2- https://ecf.dgii.gov.do/{AMBIENTE}/consultaestado/help/index.html
                        </pre>


                        </v-col>


                      </v-row>
                    </v-col>
                    <!-- FINcuerpo FACTURACION ELETRONICA -->

                  </v-card>

                </v-col>
                <!-- fn Facturacion Electronica -->
                </div>
              </v-card>


            </div>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->

        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            ">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br></br>
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import ContenidoBase from "../components/ContenidoBase"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"
import { parse } from "@fortawesome/fontawesome-svg-core";

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
  },

  created() {
    var json = {
      titulo: "Consulta Facturas",
      descripcion: "Consulta Facturas",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,

      accion: [
        "ConsultaFacturasNew",
        "ConsultaFacturasSave",
        "ConsultaFacturasRemove",
        "ConsultaFacturasAnular",
        "ConsultaFacturasPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ConsultaFacturasNew", this.new);
    // EventBus.$on("ConsultaFacturasSave", this.save);
    // EventBus.$on("ConsultaFacturasRemove", this.remove);
    // EventBus.$on("ConsultaFacturasAnular", this.remove);
    // EventBus.$on("ConsultaFacturasPrintList", this.imprimirList);
    EventBus.$on("emitConsultaFacturas", this.datostabla)
    EventBus.$on("onResize", this.onResize)


//this.actualzarinfo_factura_dgi(dt)


    this.getFacVenta()
  },

  data: () => ({
    arrayPropiedases: {
      "items-per-page-options": [10, 15, 20, 50],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
    },
    listDatos: [],
    selectedListFact: [],
    selected: [],
    RDocumento: [],
    RSucursal: [],
    listFactVent:[],
    windowSize: { width: "auto", height: "auto" },
    texAria: "",
    rowDesTab: 25,
    Reparaloading: false,
    DtoFacturaVentas:null,
    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    ConsultaFacturas: {
      ncf: null,
      opcion:1,
      factura: null,
      buscarTrackId:"",
      cantreg:0
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" },
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

    debounceTimer: null,
  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter, getParamFecha,
    onResize(e) {
      //this.windowSize=e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },

    datostabla(e) {
      this.ConsultaFacturas = e
      this.acti_tb_data = false
    },

    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    newwnuevo() {

      this.ConsultaFacturas ={
      ncf: null,
      opcion:1,
      factura: null,
      buscarTrackId:"",
      cantreg:0
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    }
        this.ejecucion = false
        EventBus.$emit("loading", false) 
        EventBus.$emit("actualizaBarraBusqueda2")
    },

 resertPaginacion() {
      this.resertPagi = false

      this.paginator.page = 1
      this.paginator.pageStart = 0
      this.paginator.pageStop = this.paginator.itemsPerPage

      var _this = this
      setTimeout(function () {
        _this.resertPagi = true
      }, 500)

      //setTimeout(this.resertPagi=true,1500);
    },

    cargarPaginacion(e) {
      this.selected = []
      // console.log('cargarPaginacion')
      //     console.log(e);
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
        // this.paginator.itemsPerPage.push(15)
      }

      this.getFacVenta()
      //   this.filtro();
    },



getFacVenta() {
      // if(this.ConsultaFacturas.NoFactura.length==0){this.ConsultaFacturas.NoFactura=0}

      if (
          (this.ConsultaFacturas.NoFactura != null && this.ConsultaFacturas.NoFactura.length == 0) ||
          this.ConsultaFacturas.NoFactura == 0
      ) {
        this.ConsultaFacturas.NoFactura = null
      }
      if (this.ConsultaFacturas.ncf != null && this.ConsultaFacturas.ncf.length == 0) {
        this.ConsultaFacturas.ncf = null
      }

      if (this.$refs.formFactVenta.validate()) {
 
        var obj = JSON.parse(JSON.stringify(this.ConsultaFacturas))
        // if (this.ConsultaFacturas.documento != null) {
        //   obj.documento = this.ConsultaFacturas.documento.codigo
        // }
        // if (this.ConsultaFacturas.cliente != null) {
        //   obj.cliente = this.ConsultaFacturas.cliente.codigo
        // }

        /*obj.limit = this.paginator.itemsPerPage*/
        obj.limit =this.ConsultaFacturas.cantreg>0?this.ConsultaFacturas.cantreg:1
        obj.ultimo = this.paginator.pageStart
 
        this.$axios
            .post(this.$hostname + this.$hName + "/ConsultaRapida/ConsultaFacturasExterna", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listFactVent = res.data.ListFactura)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },


    GetDataFact(e) {
      this.listDatos = []
      this.listDatos = e
    },

    obtenerDatoSelectFact(e) {
      this.obtenerDatoSelectFactClickRow(e.item)
    },

    obtenerDatoSelectFactClickRow(e) {
      console.log("obtenerDatoSelectFactClickRow")

      this.DtoFacturaVentas=JSON.parse(JSON.stringify(e));

     /* var obj = JSON.parse(JSON.stringify(e))
      obj.horaFactura = new Date(e.horaFactura)
      this.texAria = ""

      if (e.fecha != null) {
        var fecnac = this.getParamFecha(e.fecha)
        obj.fecha = fecnac.split("T")[0]
      }

      this.selectedListFact = []
      this.selectedListFact.push(e)

      this.$axios
        .post(this.$hostname + this.$hName + "/ConsultaRapida/GetFacturas", obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.texAria = res.data, this.ver(res.data)
          console.log("obtenerDatoSelectFactClickRow-->", res.data)

        })
        .catch(error => {
        })*/
    },


    obtenerDatoSelect(e) {
      this.datostabla(e.item)
    },

    datostabla(e) {
      var eftc = JSON.parse(JSON.stringify(e))

      this.selected = []
      this.selected.push(JSON.parse(JSON.stringify(e)))
      this.DtoFacturaVentas=JSON.parse(JSON.stringify(e))
        console.log('Inf*->',e)


     /* if (eftc.valordescuento == null) {
        e.valordescuento = 0
      }
      if (eftc.valorimpuesto == null) {
        e.valorimpuesto = 0
      }

      if (eftc.totalIsr == null) {
        e.totalIsr = 0
      }
      if (eftc.totalOtroImpuesto == null) {
        e.totalOtroImpuesto = 0
      }
      if (eftc.valor == null) {
        e.valor = 0
      }
      if (eftc.efectivo == null) {
        e.efectivo = 0
      }
      if (eftc.cheques == null) {
        e.cheques = 0
      }
      if (eftc.tarjeta == null) {
        e.tarjeta = 0
      }
      if (eftc.valorNc == null) {
        e.valorNc = 0
      }
      if (eftc.cupones == null) {
        e.cupones = 0
      }
      if (eftc.valorasignacion == null) {
        e.valorasignacion = 0
      }

      if (eftc.puntos == null) {
        e.puntos = 0
      }
      if (eftc.valorbonogas == null) {
        e.valorbonogas = 0
      }
      if (eftc.cxc == null) {
        e.cxc = 0
      }
      if (eftc.valordonacion == null) {
        e.valordonacion = 0
      }

      if (eftc.valorPruebaMetro == null) {
        e.valorPruebaMetro = 0
      }
      if (eftc.valorTraspaso == null) {
        e.valorTraspaso = 0
      }
      if (eftc.valorPruebaMetro == null) {
        e.valorPruebaMetro = 0
      }

      eftc.fecha = new Date(e.fecha).toISOString().substr(0, 10) //this.acti_tb_data=false

      eftc.facturasventaDetalleList.forEach((element) => {
        if (element.hasOwnProperty("valordescuento") && element.valordescuento != null) {
          if (element.valordescuento > 0) {
            element.descuentoPorciento = false
          } else {
            element.descuentoPorciento = true
          }
        } else {
          element.descuentoPorciento = true
          element.valordescuento = 0
        }

        if (element.hasOwnProperty("descuento") && element.descuento != null) {
          if (element.descuento > 0) {
            element.descuentoPorciento = true
          } else {
            element.descuentoPorciento = false
          }
        } else {
          element.descuentoPorciento = false
          element.descuento = 0
        }

        if (element.cantidadPendiente != element.cantidad) {
          this.alerta("Aparentemente  esta factura tiene una devolución (Revise)", "error")
        }
      })

      this.facturasVentaList = JSON.parse(JSON.stringify(eftc.facturasventaDetalleList))

      delete eftc["facturasventaDetalleList"]
      ;(this.contabilidad = null), (this.RLisCuenta = [])

      var obj = {
        UtilFacturaVentas: JSON.parse(JSON.stringify(e)),
        contabilidad: null,
      }

      this.UtilFacturaVentas = eftc*/

      /*this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/BuscarContabilidad',{
usuario:JSON.parse(JSON.stringify(this.$user)),
documento: e.facturasventaPK.documento,
secuencia: e.facturasventaPK.secuencia,
operacion: e.documentoFactura.operacion.codigo
})
.then(res=>{
if(res.data.toString().length >0){
this.contabilidad=res.data, 
this.RLisCuenta=JSON.parse(JSON.stringify(res.data.contabilidadDetalleList)),
this.calcularTotalcuenta(res.data.contabilidadDetalleList),
obj.contabilidad=JSON.parse(JSON.stringify(this.contabilidad)),
this.ObjAnteFac=JSON.stringify(obj) 
}
})*/

      /*this.$axios
          .get(
              this.$hostname +
              this.$hName +
              "/contabilidad/findContabilidad/" +
              e.facturasventaPK.documento +
              "/" +
              e.facturasventaPK.secuencia +
              "/" +
              e.documentoFactura.operacion.codigo,
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => {
            if (res.data.toString().length > 0) {
              ;(this.contabilidad = res.data),
                  (this.RLisCuenta = JSON.parse(JSON.stringify(res.data.contabilidadDetalleList))),
                  this.calcularTotalcuenta(res.data.contabilidadDetalleList),
                  (obj.contabilidad = JSON.parse(JSON.stringify(this.contabilidad))),
                  (this.ObjAnteFac = JSON.stringify(obj))
            }
          })
          .catch((error) => {
            this.alertaNotf("Dato no guardado" + error, "error")
          })

      setTimeout(this.CalcularFact, 3)*/
   
    },

    ver(e) {
      var au = e.split("\n").length
      this.rowDesTab = (au + 2)
    },

    getEstado(e){
      var ESTADO="N/A"
      if(e!=null && typeof JSON.parse(e) ==="object"){
      ESTADO=JSON.parse(e).estado
      }
      return ESTADO
    },


     claseColorEstado(e){
      var COLOR=" blue--text "
      //Aceptado: green--text  ,Rechazado: red--text ,Reenviado: orange--text ,N/A: blue--text 
      if(e!=null && typeof JSON.parse(e) ==="object"){
        var ESTADO=JSON.parse(e).estado
        if(ESTADO.includes('Aceptado')){ COLOR=" green--text "}
        if(ESTADO.includes('Rechazado')){ COLOR=" red--text "}
        if(ESTADO.includes('Reenviado')){ COLOR=" orange--text "}
      }else{
        COLOR=" blue--text "
      }
      return COLOR
    },


    getCodSeguridad(e){
    //<span style="font-size: 13px">{{props.item.contenidoJson.encabezado.codigoSeguridadeCF!=null?props.item.contenidoJson.encabezado.codigoSeguridadeCF:'N/A'}}</span>
    var   COD_SEG="N/A"

    if(e.contenidoJson.encabezado.codigoSeguridadeCF!=null){
      COD_SEG=e.contenidoJson.encabezado.codigoSeguridadeCF
    }else{
      if(e.qr!=null && e.qr.includes("codigoseguridad")){
        COD_SEG=e.qr.split("codigoseguridad=")[1]
       }
    }

    return COD_SEG;
    },

    activarModuloEletronica(FAC) {

      var BOOL_ACTIVA = false
      var activaSucursal = (FAC.hasOwnProperty("sucursal") && FAC.sucursal != null && FAC.sucursal.facturacionEletronica == true)
      if (FAC != null && FAC.hasOwnProperty("facturasventaPK") && FAC.facturasventaPK.secuencia > 0 && activaSucursal == true) {
        BOOL_ACTIVA = true
      }
      return BOOL_ACTIVA

    },


async enviarTodaFactura(){


  if(this.listFactVent.length>0){

    EventBus.$emit("loading", true) 

    //var ARRAYS_LISTFAC = this.listFactVent.filter((ee) => ee.contenidoJson.encabezado.idDoc.eNCF!=null && ee.contenidoJson.encabezado.emisor!=null && ee.contenidoJson.encabezado.totales!=null)

  var ARRAYS_LISTFAC = this.listFactVent.filter((ee) => ee.contenidoJson.encabezado.idDoc.eNCF!=null && ee.contenidoJson.encabezado.idDoc.eNCF.trim().length>0 && ee.contenidoJson.encabezado.emisor!=null && ee.contenidoJson.encabezado.totales!=null)

    console.log('ARRAYS_LISTFAC-->',ARRAYS_LISTFAC)
    
    this.$axios.post(this.$hostname + this.$hName + "/facturas-electronicas/UtilitarioGrupoFactElectronica", ARRAYS_LISTFAC,
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => 
            {
               EventBus.$emit("loading", false) 
               this.ejecucion = false
              this.alerta("Proceso ejecutado", "bien");
              var _this = this
              setTimeout(function () {
                _this.getFacVenta()
              }, 500)
            })
            .catch(error => {
              this.alerta("Dato no guardado correctamente!", "error");
             this.getFacVenta()
              EventBus.$emit("loading", false)  
              this.ejecucion = true });

  }else{
     this.alerta("No hay facturas para enviar!", "error");
  }


   




},


    actualizarFacEletronico(FAC) {

      var FACT= JSON.parse(JSON.stringify(FAC.contenidoJson))
      if (FAC.hasOwnProperty("trackId") && FAC.trackId != null && FAC.trackId.trim().length > 0 && FAC.trackId.toUpperCase().includes("ACEPTADO")) {
        this.alerta("ESTA FACTURA YA FUE ACEPTADO(Revise) !!!.", "error")
        return
      }

       if (FAC.hasOwnProperty("trackId") && FAC.trackId != null && FAC.trackId.trim().length > 0 && FAC.trackId.toUpperCase().includes("REENVIADO") ) {
        this.alerta("ESTA FACTURA YA FUE REENVIADA(Revise) !!!.", "error")
        return
      }
      EventBus.$emit("loading", true) 

            this.$axios.post(this.$hostname + this.$hName + "/facturas-electronicas", FACT,
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => 
            {
              this.alerta("Proceso ejecutado", "bien");
              
              var _this = this
              setTimeout(function () {
                _this.getFacVenta()
                //_this.actualzarinfo_factura_dgi(FAC)
              }, 500)

            })
            .catch(error => {
              this.alerta("Dato no guardado correctamente!", "error");
              EventBus.$emit("loading", false)  
              this.ejecucion = true });

      return


    },

actualzarinfo_factura_dgi(FACT){

return
var trackId= {
  codSec:FACT.codigo,
  estado:"Reenviado"
}
var objTrack={
  codSec:FACT.codigo,
  trackId: JSON.stringify(trackId)
}


this.$axios.post(this.$hostname + this.$hName + "/ConsultaRapida/actualizarInfoFactEletronica",
          objTrack, {headers: this.$store.getters.GetheadersAxios})
          .then((res) => {
              this.getFacVenta()
              EventBus.$emit("loading", false) 
          })
          .catch((error) => {
            console.log("actualizar no guardado correctamente-->", error)
            EventBus.$emit("loading", false) 
          })
},

dataFechaEmision(e){
if(e.contenidoJson.encabezado.hasOwnProperty('emisor')&& e.contenidoJson.encabezado.emisor!=null && e.contenidoJson.encabezado.emisor.hasOwnProperty('fechaEmision') && e.contenidoJson.encabezado.emisor.fechaEmision!=null){
  return e.contenidoJson.encabezado.emisor.fechaEmision;
}else{
  return '';
}
},

dataEncf(e){
if(e.contenidoJson.encabezado.hasOwnProperty('idDoc')&& e.contenidoJson.encabezado.idDoc!=null && e.contenidoJson.encabezado.idDoc.hasOwnProperty('eNCF') && e.contenidoJson.encabezado.idDoc.eNCF!=null){
  return e.contenidoJson.encabezado.idDoc.eNCF;
}else{
  return '';
}

},

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },
  },

  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    },
  },
}
</script>

<style></style>